import $ from 'jquery';

let currentInnerWidth = 0;
let currentDevice = '';
let ticking = false;

const device_dimensions = {
    width: {
        desktop: 1200,
        tablet: 992,
        tablet_portrait: 768,
    }
};


function checkViewport(innerWidth) {
    const deviceForWidth = deviceForSize(innerWidth);

    if (deviceForWidth !== currentDevice) {
        currentDevice = deviceForWidth;
        $(document).trigger('balloon:viewport', [currentDevice]);
    }
}

function deviceForSize(width) {
    if (width < device_dimensions.width.tablet_portrait) {
        return 'mobile';
    } else if (width < device_dimensions.width.tablet) {
        return 'tablet portrait';
    } else if (width < device_dimensions.width.desktop) {
        return 'tablet landscape';
    } else {
        return 'desktop';
    }
}

function observeViewport() {
    window.addEventListener('resize', function (e) {
        currentInnerWidth = window.innerWidth;

        if (!ticking) {
            window.requestAnimationFrame(function () {
                checkViewport(currentInnerWidth);
                ticking = false;
            });
            ticking = true;
        }
    });

    currentInnerWidth = window.innerWidth;

    $(document).trigger('balloon:viewport', [deviceForSize(currentInnerWidth)]);
}

export default observeViewport;
